import { render, staticRenderFns } from "./extractSimplified.vue?vue&type=template&id=5787f524"
import script from "./extractSimplified.vue?vue&type=script&lang=js"
export * from "./extractSimplified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports